module.exports = __webpack_public_path__ + "img/dcim05.fa793b8a.jpg";